<div class="page-container rmd-container container unified-context">
  <app-utility-toolbar />
  <h1 class="header col-12">
    RMD Calculation
    @if (calcComplete) {
      <button
        type="button"
        mat-button
        color="primary"
        class="header-button"
        (click)="editCalc()"
      >
        <mat-icon>create</mat-icon>Edit Calculation
      </button>
    }
    @if (calcComplete) {
      <button
        type="button"
        mat-button
        color="primary"
        class="header-button"
        (click)="resetCalc()"
      >
        <mat-icon>clear</mat-icon>Clear Calculation
      </button>
    }
  </h1>
  @if (!calcComplete) {
    <form
      #rmdForm="ngForm"
      (ngSubmit)="rmdForm.form.valid && calculate(formData)"
    >
      <div class="row">
        <div class="col-12">
          <h2>Client Information</h2>
        </div>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Issue Age</mat-label>
          <input
            matInput
            name="AgeAtIssue"
            type="number"
            placeholder="Age"
            required
            [(ngModel)]="formData.AgeAtIssue"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Mortality Age</mat-label>
          <input
            matInput
            name="MortalityAge"
            type="number"
            placeholder="Mortality Age"
            required
            [(ngModel)]="formData.MortalityAge"
          />
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-12">
          <h2>Income Annuity</h2>
        </div>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Initial Premium</mat-label>
          <input
            matInput
            name="IncomeAnnuity"
            attr.maxlength="20"
            placeholder="Initial Premium"
            required
            [maskito]="dollarMask"
            [(ngModel)]="formData.IncomeAnnuity"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Income Annuity Growth Rate</mat-label>
          <input
            matInput
            name="IncomeAnnuityRate"
            placeholder="Income Annuity Growth Rate"
            required
            [maskito]="percentMask"
            [(ngModel)]="formData.IncomeAnnuityRate"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Age to Start Income</mat-label>
          <input
            matInput
            name="AgeAtFirstWithdrawal"
            type="number"
            placeholder="Age to Start Income"
            required
            [(ngModel)]="formData.AgeAtFirstWithdrawal"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Guaranteed Annual Income</mat-label>
          <input
            matInput
            name="LifetimeIncome"
            attr.maxlength="20"
            placeholder="Guaranteed Annual Income"
            required
            [maskito]="dollarMask"
            [(ngModel)]="formData.LifetimeIncome"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Rising Income Rate</mat-label>
          <input
            matInput
            name="IncomeRisingRate"
            placeholder="Rising Income Rate"
            required
            [maskito]="percentMask"
            [(ngModel)]="formData.IncomeRisingRate"
          />
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-12">
          <h2>Investment Portfolio</h2>
        </div>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Equities</mat-label>
          <input
            matInput
            name="EquityHoldings"
            attr.maxlength="20"
            placeholder="Equities"
            required
            [maskito]="dollarMask"
            [(ngModel)]="formData.EquityHoldings"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Equity Growth Rate</mat-label>
          <input
            matInput
            name="EquityHoldingsRate"
            placeholder="Equity Growth Rate"
            required
            [maskito]="percentMask"
            [(ngModel)]="formData.EquityHoldingsRate"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Bonds</mat-label>
          <input
            matInput
            name="FixedIncome"
            attr.maxlength="20"
            placeholder="Bonds"
            required
            [maskito]="dollarMask"
            [(ngModel)]="formData.FixedIncome"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Bonds Growth Rate</mat-label>
          <input
            matInput
            name="FixedIncomeRate"
            placeholder="Bonds Growth Rate"
            required
            [maskito]="percentMask"
            [(ngModel)]="formData.FixedIncomeRate"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Investment Annuities</mat-label>
          <input
            matInput
            name="Annuity"
            attr.maxlength="20"
            placeholder="Investment Annuities"
            required
            [maskito]="dollarMask"
            [(ngModel)]="formData.Annuity"
          />
        </mat-form-field>
        <mat-form-field class="col-3 mb-3">
          <mat-label>Annuity Growth Rate</mat-label>
          <input
            matInput
            name="AnnuityRate"
            placeholder="Annuity Growth Rate"
            required
            [maskito]="percentMask"
            [(ngModel)]="formData.AnnuityRate"
          />
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-6">
          <button mat-raised-button color="accent" type="submit">
            <mat-icon>polls</mat-icon>Calculate
          </button>
        </div>
      </div>
    </form>
  }

  @if (calcComplete) {
    <div>
      <div class="row my-3">
        @for (chart of chartData; track chart) {
          <div class="chart-container col-6 mx-auto results-table">
            <highcharts-chart
              class="w-100 mx-auto"
              [Highcharts]="Highcharts"
              [options]="chart"
            />
          </div>
        }
      </div>
      <h2 class="mt-5 mb-3">
        Value at Death: {{ tableHeaderValue | currency }}
      </h2>
      <kendo-grid
        #resultsGrid="kendoGrid"
        class="col-12 search-grid"
        height="500"
        [scrollable]="true"
        [kendoGridBinding]="tableData"
        [pageable]="false"
        [sortable]="{ allowUnsort: true, mode: 'multiple' }"
        [filterable]="'menu'"
        [columnMenu]="true"
        [selectable]="false"
        [autoSize]="true"
        [navigable]="true"
      >
        <kendo-grid-column field="Age" title="Age" />
        <kendo-grid-column
          field="PortfolioValue"
          title="Investment Portfolio Value"
          format="{0:c}"
        />
        <kendo-grid-column
          field="RMDFromPortfolio"
          title="Investment Portfolio Withdrawal"
          format="{0:c}"
        />
        <kendo-grid-column
          field="RMDFromPortfolioPct"
          title="Withdrawal as Percent"
          format="{0:p2}"
        />
        <kendo-grid-column
          field="AnnuityValue"
          title="Income Annuity Value"
          format="{0:c}"
        />
        <kendo-grid-column
          field="LifetimeWithdrawal"
          title="Lifetime Income"
          format="{0:c}"
        />
        <kendo-grid-column
          field="LifetimeWithdrawalPct"
          title="Effective Withdrawal Rate"
        />
        <kendo-grid-column
          field="RMDNeeded"
          title="Required Minimum Distribution"
          format="{0:c}"
        />
        <kendo-grid-column
          field="TotalValue"
          title="Total Porfolio Value"
          format="{0:c}"
        />
      </kendo-grid>
    </div>
  }
  <ngx-loading [show]="loading" />
</div>
